import React from "react";
import { XIcon } from "@heroicons/react/solid";
import CodeEditor from "@uiw/react-textarea-code-editor";

import CodingLanguageList from "./CodingLanguageList";

function CodeSnippetModal({ openCodeSnippetModal, sendCodeData }) {
  const [language, setLanguage] = React.useState("");
  const [code, setCode] = React.useState("");

  const getLanguage = (language) => {
    setLanguage(language);
  };

  return (
    <>
      <div className="justify-center items-center flex   overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none ">
        <div className="w-[100%] relative my-6 mx-auto max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl rounded-lg shadow-md shadow-black">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full  outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 rounded-t bg-background">
              <h3 className="text-3xl font-robo  text-primary">
                Send Code Snippet
              </h3>
              <div className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full">
                <XIcon
                  className="h-5 w-5 "
                  aria-hidden="true"
                  onClick={() => openCodeSnippetModal(false)}
                />
              </div>
            </div>
            {/*body*/}
            <div className="relative px-6 pb-3 flex-auto bg-background">
              <form action="#" method="POST">
                <div className="col-span-6 sm:col-span-3">
                  <div className="w-[100%]">
                    <label className="block text-md font-robo text-primary ">
                      Select language
                      <span className="text-red"> *</span>
                    </label>
                    <div className="w-full sm:w-1/2 md:w-1/3 ">
                      <CodingLanguageList getLanguage={getLanguage} />
                    </div>
                    <label className="block text-md font-robo pb-1 text-primary  mt-2">
                      Write code here
                      <span className="text-red"> *</span>
                    </label>
                    <textarea
                      id="codeTextArea"
                      name="codeTextArea"
                      onChange={(e) => setCode(e.target.value)}
                      className="appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1 bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10 sm:text-sm my-1"
                      placeholder="// Paste code here"
                      rows={13}
                    />
                    {/* <div className="w-full h-[200px] overflow-auto">
                    <CodeEditor
                      value={code}
                      language={language.LanguageCode}
                      placeholder="Please enter JS code."
                      onChange={(evn) => setCode(evn.target.value)}
                      padding={15}
                      style={{
                        fontSize: 14,
                        backgroundColor: "#fff",
                        fontFamily:
                          "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
                      }}
                    />
                  </div> */}
                  </div>
                </div>
              </form>
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end p-3 pt-3 pr-6 rounded-b bg-background">
              <button
                className="bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                type="button"
                onClick={() => {
                  if (code !== "" && language !== "") {
                    openCodeSnippetModal(false);
                    sendCodeData({
                      Language: language.LanguageCode,
                      Code: code,
                      compilerCode: language.CompilerCode,
                    });
                  }
                }}
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-50  fixed inset-0 z-40 bg-black"></div>
    </>
  );
}

export default CodeSnippetModal;
